import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';

import orange from '@mui/material/colors/orange';
import grey from '@mui/material/colors/grey';

import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Datetime from 'components/Shared/Datetime';


const styles = {
    future: {
        color: grey[500]
    },
    depasse: {
        color: orange[500]
    }
};


class ReclamationVerificationIcon extends React.Component {
    render() {
        const { date, depasse, classes } = this.props;



        if (date !== null) {

            return (<Tooltip title={<Datetime datetime={date} />}><EventAvailableIcon className={depasse ? classes.depasse : classes.future} /></Tooltip>);
        }
        else {
            return null;
        }

    }    
}

ReclamationVerificationIcon.propTypes = {
    date: PropTypes.string,
    depasse: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReclamationVerificationIcon);